import React from 'react';
import CopyrightIcon from '@material-ui/icons/Copyright';
import { makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  footer: {
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 20,
  },
  textSize: {
    fontSize: 15,
  },
  copyright: {
    marginBottom: '0.1rem',
    marginRight: '1px',
    fontSize: 15,
  },
}));

const Footer = () => {
  const classes = useStyles();
  return (
    <div className={classes.footer}>
      <CopyrightIcon className={classes.copyright} />
      <Typography className={classes.textSize}>
        2020, Rapport.
      </Typography>
    </div>
  )
};

export default Footer;
